import Search from './ComposedSearchTemplate';
import { SearchQuery } from './SearchQuery.graphql';

Search.query = SearchQuery;

export default Search;
